import log7 from '../../assets/images/log_7.png'
import log4 from '../../assets/images/log_4.png'
import dashboardImage from '../../assets/images/dashboard-image.svg'

interface BlogPost {
  id: string
  title: string
  description: string
  date: string
  image: string
  category?: string
}

const blogPosts: BlogPost[] = [
  {
    id: 'real-time-tracking',
    title: 'HOW REAL-TIME TRACKING IS CHANGING CUSTOMER EXPECTATIONS',
    description: 'Discover how live updates from pickup to delivery are no longer just a perk — they\'re now a customer expectation. Here\'s how Speedyssey makes it seamless.',
    date: 'JAN 12, 2025',
    image: log7,
    category: 'Customer Experience'
  },
  {
    id: 'future-logistics-africa',
    title: 'THE FUTURE OF NEW WNW LOGISTICS IN AFRICA: WHAT\'S NEW?',
    description: 'A deep dive into how emerging tech, modest fast logistics, and last-mile innovation are reshaping African commerce. Here\'s how Speedyssey makes it seamless.',
    date: 'JAN 12, 2025',
    image: log4,
    category: 'Industry Trends'
  },
  {
    id: 'seller-dashboard-features',
    title: 'USING THE SELLER DASHBOARD: 5 UNDERRATED FEATURES YOU SHOULD KNOW',
    description: 'You might be underutilizing some powerful features. Here\'s how to streamline your order management and reduce failed deliveries.',
    date: 'JAN 12, 2025',
    image: dashboardImage,
    category: 'Product Updates'
  }
]

function Insights() {
  return (
    <section className="bg-white py-20 px-4">
      <div className="container sm:px-10 px-3  mx-auto">
        {/* Header Section */}
        <div className="flex justify-between items-start mb-12">
          <div className="max-w-2xl">
            <h2 
              className="text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-4 leading-tight"
              style={{ fontFamily: 'Antonio, sans-serif' }}
            >
              LOGISTICS INSIGHTS &<br />
              INDUSTRY UPDATES
            </h2>
            
            <p className="text-gray-600 text-lg leading-relaxed">
              Explore expert tips, company news, and the latest trends shaping the future of global logistics.
            </p>
          </div>

          <a
            href="/news"
            className="flex items-center gap-2 text-[#2C2C2C] hover:text-[#F55109] transition-colors duration-300 group"
          >
            <span className="text-base font-medium">View More &rarr;</span>
          </a>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="group cursor-pointer">
              {/* Image */}
              <div className="relative overflow-hidden rounded-lg mb-6">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-96 object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
              </div>

              {/* Content */}
              <div>
                <h3 
                  className="text-xl font-bold text-[#2C2C2C] mb-4 leading-tight group-hover:text-[#F55109] transition-colors duration-300"
                  style={{ fontFamily: 'Antonio, sans-serif' }}
                >
                  {post.title}
                </h3>
                
                <p className="text-gray-600 text-base leading-relaxed mb-4">
                  {post.description}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-[#F55109] text-sm font-semibold">
                    {post.date}
                  </span>
                  
                  {post.category && (
                    <span className="text-gray-400 text-sm">
                      {post.category}
                    </span>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Mobile View More Button */}
        <div className="flex justify-center mt-12 md:hidden">
          <button className="flex items-center gap-2 text-[#2C2C2C] hover:text-[#F55109] transition-colors duration-300 group bg-gray-100 hover:bg-gray-200 px-6 py-3 rounded-full">
            <span className="text-base font-medium">View All Insights &rarr;</span>
            
          </button>
        </div>
      </div>
    </section>
  )
}

export default Insights